import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type GetShipmentPODFactoryDependencies = {
  repository: ShipmentRepository
}

export function getShipmentPODFactory({ repository }: GetShipmentPODFactoryDependencies) {
  return async function getPOD(
    uuid: string,
    config?: { signal?: AbortSignal; enableAttachmentsEndpointForPods?: boolean }
  ) {
    try {
      return await repository.getPODs(uuid, config, config?.enableAttachmentsEndpointForPods)
    } catch (error) {
      throw new Error('Failed to get the POD', { cause: error as Error })
    }
  }
}

export function getShipmentPODs(
  id: string,
  config?: { signal?: AbortSignal; enableAttachmentsEndpointForPods?: boolean }
) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const get = getShipmentPODFactory({ repository })

  return get(id, config)
}
